module.exports = __webpack_public_path__ + "img/table.5d18279e.jpg";